/* eslint-disable */
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { getLPLentesDeContacto } from "../../../project/services/LenteContactoService";
import { getCacheData } from "../../services/CacheService";
import ListaPrecioLenteContacto from "./ListaPrecioLenteContacto";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialSearchData = {
  lenteContactoMarca: "",
  lenteContactoSubMarca: "",
  lenteContactoTiempoUso: "",
  lenteContactoTipo: "",
  lenteContactoMaterial: "",
  lenteContactoDiagnostico: "",
  lenteContactoColor: "",
  disponibleObraSocial: "T",
};

const disponibleObraSocial = [
  {
    id: "T",
    descripcion: "Todos",
  },
  {
    id: "S",
    descripcion: "Sí",
  },
  {
    id: "N",
    descripcion: "No",
  },
];
//
// ################################################################################
//
const BuscarLPLenteContactoDialog = ({ open, onClose, onSelect }) => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [lpLentesContacto, setLpLentesContacto] = useState([]);
  const [idLpLentesContacto, setIdLpLentesContacto] = useState("");
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [showLPLenteContactoTable, setShowLPLenteContactoTable] = useState(true);
  const [showLPLenteContacto, setShowLPLenteContacto] = useState(false);
  const [title, setTitle] = useState("Búsqueda de Listas de Precios de Lentes de Contacto");
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [lcMarcas, setLcMarcas] = useState([]);
  const [lcSubMarcas, setLcSubMarcas] = useState([]);
  const [lcTiemposUso, setLcTiemposUso] = useState([]);
  const [lcTipos, setLcTipos] = useState([]);
  const [lcMateriales, setLcMateriales] = useState([]);
  const [lcDiagnosticos, setLcDiagnosticos] = useState([]);
  const [lcColores, setLcColores] = useState([]);

  const tableColumns = [
    {
      field: "descripcion_lc_marca",
      headerName: "Marca",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_marca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_submarca",
      headerName: "Submarca",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_submarca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_presentacion",
      headerName: "Presentación",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_presentacion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "venta_por_unidad",
      headerName: "Vx unidad",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.venta_por_unidad ? "SI" : "NO";
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_tiempo_uso",
      headerName: "Tiempo de uso",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_tiempo_uso;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_tipo",
      headerName: "Tipo",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_material",
      headerName: "Material",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_material;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_diagnostico",
      headerName: "Diagnóstico",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_diagnostico;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_color",
      headerName: "Color",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_color;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.cu !== "view" && (
            <Tooltip title="seleccionar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => verLPLenteContacto(params.row.id_lc_lprecio)}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadLcMarcas();
    loadLcSubMarcas();
    loadLcTiemposUso();
    loadLcTipos();
    loadLcMateriales();
    loadLcDiagnosticos();
    loadLcColores();
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const loadLcMarcas = async () => {
    const response = await getCacheData("lc_marca");
    if (response.ok) {
      setLcMarcas(response.data.data);
    } else {
      setLcMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcSubMarcas = async () => {
    const response = await getCacheData("lc_submarca");
    if (response.ok) {
      setLcSubMarcas(response.data.data);
    } else {
      setLcSubMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcTiemposUso = async () => {
    const response = await getCacheData("lc_tiempo_uso");
    if (response.ok) {
      setLcTiemposUso(response.data.data);
    } else {
      setLcTiemposUso([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcTipos = async () => {
    const response = await getCacheData("lc_tipo");
    if (response.ok) {
      setLcTipos(response.data.data);
    } else {
      setLcTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcMateriales = async () => {
    const response = await getCacheData("lc_material");
    if (response.ok) {
      setLcMateriales(response.data.data);
    } else {
      setLcMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcDiagnosticos = async () => {
    const response = await getCacheData("lc_diagnostico");
    if (response.ok) {
      setLcDiagnosticos(response.data.data);
    } else {
      setLcDiagnosticos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcColores = async () => {
    const response = await getCacheData("lc_color");
    if (response.ok) {
      setLcColores(response.data.data);
    } else {
      setLcColores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      lenteContactoMarca: searchData.lenteContactoMarca,
      lenteContactoSubMarca: searchData.lenteContactoSubMarca,
      lenteContactoTiempoUso: searchData.lenteContactoTiempoUso,
      lenteContactoTipo: searchData.lenteContactoTipo,
      lenteContactoMaterial: searchData.lenteContactoMaterial,
      lenteContactoDiagnostico: searchData.lenteContactoDiagnostico,
      lenteContactoColor: searchData.lenteContactoColor,
      disponibleObraSocial: searchData.disponibleObraSocial,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getLPLentesDeContacto(_params);
    setIsDoingSomething(false);

    if (response.ok) {

      setTotalRowsCount(response.data.count);
      setLpLentesContacto(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const verLPLenteContacto = (parIdLpLentesContacto) => {

    setIdLpLentesContacto(parIdLpLentesContacto);
    setTitle("Lista de Precios de Lentes de Contacto");
    setShowLPLenteContactoTable(false);
    setShowLPLenteContacto(true);
  };

  // ################################################################################
  //
  const handleCloseDialog = () => {
    if (showLPLenteContacto) {
      handleCloseListaPrecioLenteContacto();
    } else {
      onClose({});
    }
  };
  //
  // ################################################################################
  //
  const handleCloseListaPrecioLenteContacto = () => {
    setShowLPLenteContactoTable(true);
    setShowLPLenteContacto(false);
    setTitle("Búsqueda de Listas de Precios de Lentes de Contacto");
  };
  //
  // ################################################################################
  //
  const handleSelectCorreccion = (parCorreccion) => {
    onClose(parCorreccion);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {title}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {/* busqueda de lp de lc */}
          {showLPLenteContactoTable && (
            <>
              {/* criterios de busqueda */}
              <Box>
                <Grid container spacing={1} sx={{ pb: 1 }}>
                  {/* Marca */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth sx={{ width: "100%" }}>
                      <InputLabel id="marca-select-label">Marca</InputLabel>
                      <Select
                        labelId="marca-select-label"
                        id="marca-select"
                        name="lenteContactoMarca"
                        value={searchData.lenteContactoMarca}
                        label="Marca"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {lcMarcas.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Submarca */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth sx={{ width: "100%" }}>
                      <InputLabel id="submarca-select-label">Submarca</InputLabel>
                      <Select
                        labelId="submarca-select-label"
                        id="submarca-select"
                        name="lenteContactoSubMarca"
                        value={searchData.lenteContactoSubMarca}
                        label="Submarca"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {lcSubMarcas.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Tiempo de uso */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth sx={{ width: "100%" }}>
                      <InputLabel id="tiempo-uso-select-label">Tiempo de Uso</InputLabel>
                      <Select
                        labelId="tiempo-uso-select-label"
                        id="tiempo-uso-select"
                        name="lenteContactoTiempoUso"
                        value={searchData.lenteContactoTiempoUso}
                        label="Tiempo de Uso"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {lcTiemposUso.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.valor}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Tipo */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth sx={{ width: "100%" }}>
                      <InputLabel id="tipo-select-label">Tipo</InputLabel>
                      <Select
                        labelId="tipo-select-label"
                        id="tipo-select"
                        name="lenteContactoTipo"
                        value={searchData.lenteContactoTipo}
                        label="Tipo"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {lcTipos.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Material */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth sx={{ width: "100%" }}>
                      <InputLabel id="material-select-label">Material</InputLabel>
                      <Select
                        labelId="material-select-label"
                        id="material-select"
                        name="lenteContactoMaterial"
                        value={searchData.lenteContactoMaterial}
                        label="material"
                        size="small"
                        onChange={handleChange}
                      >
                        {lcMateriales.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Diagnostico */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth sx={{ width: "100%" }}>
                      <InputLabel id="diagnostico-select-label">Diangóstico</InputLabel>
                      <Select
                        labelId="diagnostico-select-label"
                        id="diagnostico-select"
                        name="lenteContactoDiagnostico"
                        value={searchData.lenteContactoDiagnostico}
                        label="diagnostico"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {lcDiagnosticos.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Color */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth sx={{ width: "100%" }}>
                      <InputLabel id="color-select-label">Color</InputLabel>
                      <Select
                        labelId="color-select-label"
                        id="color-select"
                        name="lenteContactoColor"
                        value={searchData.lenteContactoColor}
                        label="color"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {lcColores.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* disponible para obra social */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth sx={{ width: "100%" }}>
                      <InputLabel id="disponible-os-select-label">
                        Disponible para Obras Sociales
                      </InputLabel>
                      <Select
                        labelId="disponible-os-select-label"
                        id="disponible-os-select"
                        name="disponibleObraSocial"
                        value={searchData.disponibleObraSocial}
                        label="Disponible para Obras Sociales"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {disponibleObraSocial.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>

              {/* bottoners de accion */}
              <Box sx={{ mb: 1, float: "right" }}>
                <Button sx={{ mr: 1 }} variant="contained" onClick={handleBuscar}>
                  Buscar
                </Button>
                <Button sx={{ mr: 1 }} variant="outlined" onClick={handleLimpiar}>
                  Limpiar
                </Button>
              </Box>

              {/* table de lp de lc */}
              <Paper
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  border: "1px solid LightGrey",
                }}
              >

                <DataGrid
                  rows={lpLentesContacto}
                  columns={tableColumns}
                  {...tableOptions}
                />

              </Paper>
            </>
          )}

          {showLPLenteContacto && (
            <ListaPrecioLenteContacto
              idLpLentesContacto={idLpLentesContacto}
              onSelectCorreccion={handleSelectCorreccion}
              onClose={handleCloseListaPrecioLenteContacto}
            />
          )}
        </DialogContent>
      </Dialog>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default BuscarLPLenteContactoDialog;
